import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  dialogbox:{
    backgroundColor: "#e5e5e5",
    alignItems: "center",
    padding: 5,
  }
}));

export default useStyles;
